<template>
    <nav class="breadcrumb">
        <router-link class="breadcrumb-item" to="/" active-class="">Home</router-link>
        <router-link class="breadcrumb-item" active-class="" v-for="(bc, index) in breadcrumb" :to="{name: bc.name, params: bc.params, query: bc.query}" :key="index" exact>{{bc.display || bc.name}}</router-link>
        <span class="breadcrumb-item active">{{current}}</span>
    </nav>
</template>

<script>
export default {
  name: 'Breadcrump',
  props: {
    breadcrumb: {
      required: false,
      type: Array,
    },
    current: {
      required: false,
      type: String,
    }
  },
}
</script>

<style scoped>
    .breadcrumb {
        margin-bottom: 20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/utilities/Breadcrumb.vue